module.exports = __webpack_public_path__ + "static/media/aditya.a99881ac.jpeg";